import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import $ from 'jquery';

import DeleteActivityReveal from './reveal/DeleteActivityReveal';
import * as bookActions from '../../actions/bookActions';
import * as contentActions from '../../actions/contentActions';
import * as classroomActions from '../../actions/classroom/classroomActions';
import * as classroomGroupActions from '../../actions/classroom/classroomGroupActions';
import * as customTranslate from '../../services/translate/customTranslateService';
import { ROLE } from '../../const';
import * as bookService from '../../services/domain/bookService';
import AddLessonLinkReveal from './reveal/AddLessonLinkReveal';
import { isElectronApp } from '../../services/crossPlatform/crossPlatformService';
import BookDownloadBar from './BookDownloadBar/BookDownloadBar';
import UnitsErrorBoundary from './UnitsErrorBoundary';
import * as contentUtils from '../../utils/contentUtils';
import BookHeader from './BookHeader';
import BookUnitsContainer from './BookUnitsContainer';
import AddLessonAutoExecReveal from './reveal/AddLessonAutoExecReveal';

class BookContainer extends React.Component {
  state = {
    title: '',
    saveBookAlreadyCalled: false,
    edit: false,
    openingBook: true
  };

  componentDidMount = () => {
    const { classroomId, bookId, bookActions } = this.props;
    bookActions.getBookInfo(classroomId, bookId);
  };

  componentWillUnmount = () => {
    const { bookActions } = this.props;
    bookActions.setBookInfo();
  };

  componentDidUpdate(prevProps) {
    const { language, classroomId, bookId, book, unitId, user, role, bookActions } = this.props;

    const { saveBookAlreadyCalled, openingBook } = this.state;
    let newBookName = book.name;

    let prevBookId = prevProps.bookId;
    let prevClassroomId = prevProps.classroomId;
    if ((bookId !== prevBookId || classroomId !== prevClassroomId) && classroomId) {
      bookActions.getBookInfo(classroomId, bookId);
      this.resetCoverImageClassName();
    }
    if (prevProps.user !== user && classroomId) {
      bookActions.getBookInfo(classroomId, bookId);
    }

    if (prevProps !== this.props && newBookName !== book.name) {
      let title = customTranslate.translateObject(newBookName, language);
      this.setState({ title: title });
    }

    if (!saveBookAlreadyCalled) {
      this.downloadBookIfRequired(classroomId, unitId);
    }

    if (!_.isEmpty(book)) {
      const bookHasUnits = book.content && book.content[0];
      if (bookHasUnits && openingBook) {
        const firstUnitActivityId = bookService.removeNotAllowedCharactersToActivityId(book.content[0].activityId);
        setTimeout(() => bookActions.setOpenUnit(firstUnitActivityId), 300);
        this.setState({ openingBook: false });
      }
    } else if (!_.isEmpty(prevProps.book) && !_.isEmpty(book)) {
      if (prevProps.book.content.length < book.content.length) {
        const newUnit = _.differenceBy(book.content, prevProps.book.content, 'activityId');
        if (!_.isEmpty(newUnit)) {
          const newUnitActivityId = bookService.removeNotAllowedCharactersToActivityId(newUnit[0].activityId);
          if (role === ROLE.INSTRUCTOR) {
            bookActions.setUnitEdition(newUnitActivityId);
          }
        }
      }
    }
    if ((role && role === ROLE.INSTRUCTOR) || (role !== prevProps.role && role === ROLE.INSTRUCTOR)) {
      this.fetchDataForInstructors();
    }
  }

  fetchDataForInstructors = () => {
    const { classroomId, classroomGroupActions, classroomActions } = this.props;
    classroomGroupActions.getClassroomGroups(classroomId);
    classroomActions.getClassroomParticipants(classroomId);
  };

  resetCoverImageClassName = () => {
    $('.book-landscape').removeClass('loaded');
  };

  downloadBookIfRequired = (classroomId, singleUnitModeUnitId) => {
    const { contentActions, language, isAppOnline, contentBooks, book, institution } = this.props;
    if (isAppOnline && isElectronApp() && singleUnitModeUnitId && !_.isEmpty(book) && !_.isEmpty(institution)) {
      const isBookDownloaded = contentUtils.isStoreContentBookDownloaded(book, contentBooks);
      const isBookSaving = contentUtils.isStoreContentBookSaving(book, contentBooks);
      const isBookPaused = contentUtils.isStoreContentBookPaused(book, contentBooks);
      const isBookSyncing = contentUtils.isStoreContentBookSynchronizing(book, contentBooks);
      const isBookDownloading = isBookSaving && !isBookPaused;

      if (!isBookDownloaded && !isBookDownloading && !isBookSyncing) {
        let title = customTranslate.translateObject(book.name, language);
        this.setState({ saveBookAlreadyCalled: true }, () => {
          setTimeout(contentActions.saveBook(classroomId, book, title), 5000);
        });
      }
    }
  };

  render() {
    const { bookId, classroomId, unitId, book, imageSrc, isComplete, isPreview } = this.props;
    const bookContainer = book && book.disabled ? 'book-container columns disabled' : 'book-container columns';

    return (
      <div className="row book-view">
        <div className={bookContainer}>
          <BookHeader book={book} unitId={unitId} imageSrc={imageSrc} isComplete={isComplete} isPreview={isPreview} />
          <BookDownloadBar bookId={bookId} classId={classroomId} />
          <UnitsErrorBoundary unitId={unitId} book={book}>
            <BookUnitsContainer
              book={book}
              unitId={unitId}
              isComplete={isComplete}
              isPreview={isPreview}
              creatingUnit={this.props.creatingUnit}
            />
          </UnitsErrorBoundary>
        </div>
        <AddLessonLinkReveal idBook={bookId} idClassroom={classroomId} />
        <AddLessonAutoExecReveal idClassroom={classroomId} />
        <DeleteActivityReveal idBook={bookId} idClassroom={classroomId} />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  role: state.classrooms.selectedClassroom.classroom.role,
  user: state.account.user,
  language: state.account.user.language,
  isAppOnline: state.connection.status.online,
  institution: state.school.school,
  contentBooks: state.content.contentBooks,
  selectedUnit: state.book.selectedUnit
});

const mapDispatchToProps = dispatch => ({
  bookActions: bindActionCreators(bookActions, dispatch),
  classroomActions: bindActionCreators(classroomActions, dispatch),
  classroomGroupActions: bindActionCreators(classroomGroupActions, dispatch),
  contentActions: bindActionCreators(contentActions, dispatch),
  dispatch
});

BookContainer.propTypes = {
  book: PropTypes.object.isRequired,
  isComplete: PropTypes.bool,
  isPreview: PropTypes.bool,
  language: PropTypes.string,
  classroomId: PropTypes.string,
  classroomGroupActions: PropTypes.object,
  user: PropTypes.object,
  classroomActions: PropTypes.object,
  bookActions: PropTypes.object,
  bookId: PropTypes.string,
  unitId: PropTypes.string,
  selectedUnit: PropTypes.object,
  isAppOnline: PropTypes.any,
  institution: PropTypes.object,
  imageSrc: PropTypes.string,
  contentActions: PropTypes.object,
  contentBooks: PropTypes.object,
  role: PropTypes.string,
  creatingUnit: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(BookContainer);
